import {Menu, X} from 'lucide-react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import NavbarMyColonyLink from '@/components/NavbarMyColonyLink'
import NavbarTokenSearch from '@/components/NavbarTokenSearch'
import NavbarWallet from '@/components/NavbarWallet'
import { useWatchlist } from '@/hooks/useWatchlist'

const navLinks = [
  { to: '/launchpad', label: 'Launchpad' },
  { to: '/presale', label: 'Presale' },
  { to: '/submit?type=presale', label: 'Create' },
  { to: '/how-it-works', label: 'How it works' },
  { to: '/explore-colony', label: 'Explore the Colony' },
  { to: '/colony-newsfeed', label: 'Colony Newsfeed' },
]

function Navbar() {
  const [open, setOpen] = useState(false)
  const { ids: watchIds } = useWatchlist()

  return (
    <header className="px-3 pt-3 sm:px-4">
      <nav
        className="relative z-20 mx-auto flex max-w-7xl items-center justify-between rounded-2xl border border-white/10 bg-black/55 px-3 py-2 shadow-[0_12px_40px_rgba(0,0,0,0.45)] backdrop-blur-xl sm:px-4"
        aria-label="Main navigation"
      >
        <NavLink to="/" className="flex flex-shrink-0 items-center gap-2" onClick={() => setOpen(false)}>
          <img
            src="https://static.lumi.new/f4/f4a3f87cac571f6c3dd0b7f47b53b4fb.webp"
            alt="Penguin Pad logo — geometric penguin mark next to the PenguinPad.xyz wordmark"
            className="h-12 w-auto sm:h-14"
          />
        </NavLink>

        <div className="mx-2 hidden min-w-0 flex-1 sm:mx-4 md:block">
          <NavbarTokenSearch className="mx-auto max-w-sm" />
        </div>

        <div className="flex items-center gap-2">
          <NavbarWallet compact className="px-3 py-2" />
          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white hover:bg-white/5"
            onClick={() => setOpen(!open)}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>

      <div className="mx-auto mt-2 max-w-7xl md:hidden">
        <NavbarTokenSearch />
      </div>

      {open
        ? (
            <div className="mx-auto mt-2 max-w-7xl rounded-2xl border border-white/10 bg-black/80 px-3 py-3 backdrop-blur-xl">
              <div className="flex flex-col gap-1">
                {navLinks.map(link => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center justify-between rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors ${
                        isActive
                          ? 'bg-lime-400/15 text-lime-400'
                          : 'text-zinc-400 hover:bg-white/5 hover:text-white'
                      }`}
                  >
                    {link.label}
                  </NavLink>
                ))}
                <NavbarMyColonyLink
                  onNavigate={() => setOpen(false)}
                  badge={watchIds.length}
                  className={isActive =>
                    `flex items-center justify-between rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-lime-400/15 text-lime-400'
                        : 'text-zinc-400 hover:bg-white/5 hover:text-white'
                    }`}
                />
              </div>
            </div>
          )
        : null}
    </header>
  )
}

export default Navbar
